import Wrapper from '@/components/base/Wrapper';
import SuccessPage from '@/pages/Success';
import MenuLite from '@/components/menu/MenuLite';

export default [
  // Admin Cerdas :: Dashboard Admin
  {
    path: '/report-admin',
    name: 'ReportAdminIndex',
    component: () => import(/* webpackChunkName: "report-index" */ '@/pages/report/Admin'),
    meta: { rule: 'isCerdasAdmin', layout: 'default', breadCrumb: 'menu.report_school' }
  },

  // Admin Cerdas :: School Pro
  {
    path: '/school-pro',
    component: Wrapper,
    meta: { breadCrumb: 'content.school_management', layout: 'default' },
    children: [
      {
        path: '',
        name: 'SchoolIndex',
        component: () => import(/* webpackChunkName: "school-index" */ '@/pages/school'),
        meta: { rule: 'isCerdasAdmin', layout: 'default' }
      },
      {
        path: 'create',
        name: 'SchoolCreate',
        component: () => import(/* webpackChunkName: "school-form" */ '@/pages/school/CreateEdit'),
        meta: { rule: 'isCerdasAdmin', layout: 'default', breadCrumb: 'content.school_create' }
      },
      {
        path: ':id/edit',
        name: 'SchoolEdit',
        component: () => import(/* webpackChunkName: "school-form" */ '@/pages/school/CreateEdit'),
        meta: { rule: 'isCerdasAdmin', layout: 'default', breadCrumb: 'content.school_edit' }
      },
      {
        path: ':id/view',
        name: 'SchoolDetail',
        component: () => import(/* webpackChunkName: "school-form" */ '@/pages/school/CreateEdit'),
        meta: { rule: 'isCerdasAdmin', layout: 'default', breadCrumb: 'content.school_view' },
        props: { editable: false }
      },
      {
        path: 'success',
        name: 'SchoolSuccess',
        component: SuccessPage,
        meta: { rule: 'isCerdasAdmin' },
        props: { type: 'school' }
      },
      {
        path: 'success',
        name: 'SchoolUpdateSuccess',
        component: SuccessPage,
        meta: { rule: 'isCerdasAdmin' },
        props: { type: 'school-update' }
      }
    ]
  },

  // Admin Cerdas :: User
  {
    path: '/user',
    component: Wrapper,
    meta: { breadCrumb: 'content.user_list' },
    children: [
      {
        path: '',
        name: 'MasterUser',
        component: () => import(/* webpackChunkName: "user-index" */ '@/pages/user'),
        meta: { rule: 'isCerdasAdmin', layout: 'default' }
      },
      {
        path: 'create',
        name: 'MasterUserCreate',
        component: () => import(/* webpackChunkName: "user-form" */ '@/pages/user/CreateEdit'),
        meta: { rule: 'isCerdasAdmin', layout: 'default', breadCrumb: 'content.user_create' }
      },
      {
        path: ':id/edit',
        name: 'MasterUserEdit',
        component: () => import(/* webpackChunkName: "user-form" */ '@/pages/user/CreateEdit'),
        meta: { rule: 'isCerdasAdmin', layout: 'default', breadCrumb: 'content.user_edit' }
      },
      {
        path: ':id/view',
        name: 'MasterUserDetail',
        component: () => import(/* webpackChunkName: "school-form" */ '@/pages/user/CreateEdit'),
        meta: { rule: 'isCerdasAdmin', layout: 'default', breadCrumb: 'content.user_detail' },
        props: { editable: false }
      },
      {
        path: 'success',
        name: 'UserSuccess',
        component: SuccessPage,
        meta: { rule: 'isCerdasAdmin' },
        props: { type: 'useradmin' }
      },
      {
        path: 'success',
        name: 'UserUpdateSuccess',
        component: SuccessPage,
        meta: { rule: 'isCerdasAdmin' },
        props: { type: 'user-update' }
      }
    ]
  },

  // Admin Cerdas :: User Lite Manajement
  {
    path: '/user-lite',
    component: Wrapper,
    meta: { breadCrumb: 'menu.user_lite' },
    children: [
      {
        path: '',
        name: 'MasterUserLite',
        component: () => import(/* webpackChunkName: "user-index" */ '@/pages/user-lite'),
        meta: { rule: 'isCerdasAdmin', layout: 'default' }
      },
      {
        path: ':id/edit',
        name: 'MasterUserLiteEdit',
        component: () => import(/* webpackChunkName: "user-form" */ '@/pages/user-lite/CreateEdit'),
        meta: { rule: 'isCerdasAdmin', layout: 'default', breadCrumb: 'content.user_edit' }
      },
      {
        path: ':id/view',
        name: 'MasterUserLiteDetail',
        component: () => import(/* webpackChunkName: "school-form" */ '@/pages/user-lite/CreateEdit'),
        meta: { rule: 'isCerdasAdmin', layout: 'default', breadCrumb: 'content.user_detail' },
        props: { editable: false }
      },
      {
        path: 'success',
        name: 'UserLiteUpdateSuccess',
        component: SuccessPage,
        meta: { rule: 'isCerdasAdmin' },
        props: { type: 'user-lite-update' }
      }
    ]
  },

  // Admin Cerdas :: Role
  {
    path: '/role',
    component: Wrapper,
    meta: { breadCrumb: 'content.role_title' },
    children: [
      {
        path: '',
        name: 'Role',
        component: () => import(/* webpackChunkName: "role-index" */ '@/pages/role'),
        meta: { rule: 'isCerdasAdmin', layout: 'default' }
      },
      {
        path: 'success',
        name: 'PermissionUpdateSuccess',
        component: () => import(/* webpackChunkName: "role-success" */ '@/pages/Success'),
        meta: { rule: 'isCerdasAdmin' },
        props: { type: 'update-permission' }
      }
    ]
  },

  // Admin Cerdas :: Setting Lite
  {
    path: '/setting-lite',
    component: Wrapper,
    meta: { breadCrumb: 'content.setting_lite' },
    children: [
      {
        path: '',
        name: 'MenuListLite',
        component: MenuLite,
        meta: { rule: 'isCerdasAdmin', layout: 'default' },
        props: { type: 'cerdas-admin' }
      },
      {
        path: 'cerdas-lite',
        name: 'RoleLite',
        component: () => import(/* webpackChunkName: "role-index" */ '@/pages/role-lite'),
        meta: { rule: 'isCerdasAdmin', layout: 'default', breadCrumb: 'content.cerdas_feature' }
      },
      {
        path: 'change-storage',
        name: 'ChangeStorage',
        component: () => import(/* webpackChunkName: "role-index" */ '@/pages/storage'),
        meta: { rule: 'isCerdasAdmin', layout: 'default', breadCrumb: 'content.change_storage' }
      },
      {
        path: 'success',
        name: 'PermissionLiteUpdateSuccess',
        component: () => import(/* webpackChunkName: "role-success" */ '@/pages/Success'),
        meta: { rule: 'isCerdasAdmin' },
        props: { type: 'update-permission-lite' }
      }
    ]
  },
  // Admin Cerdas :: School
  {
    path: '/school',
    component: Wrapper,
    meta: { breadCrumb: 'content.school_list', layout: 'default' },
    children: [
      {
        path: '',
        name: 'SchoolV1Index',
        component: () => import(/* webpackChunkName: "school-index" */ '@/pages/school-v1'),
        meta: { rule: 'isCerdasAdmin', layout: 'default' }
      },
      {
        path: ':id/edit',
        name: 'SchoolV1Edit',
        component: () => import(/* webpackChunkName: "school-form" */ '@/pages/school-v1/CreateEdit'),
        meta: { rule: 'isCerdasAdmin', layout: 'default', breadCrumb: 'content.school_edit' }
      },
      {
        path: 'success',
        name: 'SchoolV1UpdateSuccess',
        component: SuccessPage,
        meta: { rule: 'isCerdasAdmin' },
        props: { type: 'schoolv1-update' }
      }
    ]
  }
];
